import { css, SerializedStyles } from '@emotion/core'
import * as React from 'react'

import { breakpoints } from '../constants/breakPoints'

interface DividerProps {
  className?: string
  size: number
  isTop?: boolean
  isBottom?: boolean
  fullScreenWidth?: boolean
  notDecreased?: boolean
  color?: string
  cssStyles?: SerializedStyles
}

const Divider: React.FunctionComponent<DividerProps> = ({
  className,
  color,
  size,
  isTop = true,
  isBottom = true,
  fullScreenWidth = false,
  notDecreased = false,
  cssStyles,
}) => {
  return (
    <div
      className={`${fullScreenWidth ? 'full-screen-relative' : undefined} ${className}`}
      css={[
        css`
          width: 100%;
          height: 1px;
          background: ${color ? color : '#efeff0'};
          display: block;
          position: relative;
          ${isTop && `margin-top: ${size}rem;`}
          ${isBottom && `margin-bottom: ${size}rem;`}
        @media screen and (max-width: ${breakpoints.medium}px) {
            ${isTop && !notDecreased && `margin-top: calc(${size}rem/2);`}
            ${isBottom && !notDecreased && `margin-bottom: calc(${size}rem/2);`}
          }
        `,
        cssStyles,
      ]}
    />
  )
}

export default Divider
